import type { RouterOutputs } from '@klear/ui/lib/trpc'
import {
  EMPTY_CUSTOMER_FORM as BASE_EMPTY_CUSTOMER_FORM,
  customerFormToCreateWire,
  customerFormToUpdateWire,
  customerReadToForm,
  type CustomerForm,
  type CustomerFormDirty
} from '@klear/customer/wire.client'
import {
  creditFormDirtyIsEmpty,
  creditFormToCreateWire,
  creditFormToUpdateWire,
  creditReadToForm,
  EMPTY_CREDIT_FORM,
  type CreditForm,
  type CreditFormDirty
} from '@klear/credit/wire.client'
import keys from 'lodash/keys'

export type CustomerRecord = NonNullable<RouterOutputs['customer']['get']>
export type CreditRecord = NonNullable<RouterOutputs['credit']['get']>

export type CustomerWizardFormValues = CustomerForm & CreditForm
export type CustomerWizardFormDirty = CustomerFormDirty & CreditFormDirty

export const EMPTY_CUSTOMER_FORM: CustomerWizardFormValues = {
  ...BASE_EMPTY_CUSTOMER_FORM,
  ...EMPTY_CREDIT_FORM
}

export type CustomerCreateData = ReturnType<typeof customerFormToCreateWire>
export type CustomerUpdateData = ReturnType<typeof customerFormToUpdateWire>
export type CreditCreateData = ReturnType<typeof creditFormToCreateWire>
export type CreditUpdateData = ReturnType<typeof creditFormToUpdateWire>

export function customerToFormValues(customer: CustomerRecord, credit?: CreditRecord | null): CustomerWizardFormValues {
  return {
    ...customerReadToForm(customer),
    ...(credit != null ? creditReadToForm(credit) : EMPTY_CREDIT_FORM)
  }
}

export function formValuesToCreateData(values: CustomerWizardFormValues): CustomerCreateData {
  return customerFormToCreateWire(values)
}

export function formValuesToUpdateData(
  values: CustomerWizardFormValues,
  dirty: CustomerWizardFormDirty
): CustomerUpdateData {
  return customerFormToUpdateWire(values, dirty)
}

export function formValuesToCreditCreateData(values: CustomerWizardFormValues): CreditCreateData {
  return creditFormToCreateWire(values)
}

export function formValuesToCreditUpdateData(
  values: CustomerWizardFormValues,
  dirty: CustomerWizardFormDirty
): CreditUpdateData {
  return creditFormToUpdateWire(values, dirty)
}

export function creditSubmitNeeded(
  mode: 'create' | 'edit',
  values: CustomerWizardFormValues,
  dirty: CustomerWizardFormDirty
): boolean {
  if (mode === 'create') {
    return keys(creditFormToCreateWire(values)).length > 0
  }
  return !creditFormDirtyIsEmpty(dirty)
}
